import Vue from 'vue';
import Vuetify, { VSnackbar, VIcon, VBtn } from 'vuetify/lib'
import 'typeface-dm-sans/index.css'
// import 'npm-font-source-sans-pro/source-sans-pro.css'
import i18n from './i18n'
import VuetifyDialog from 'vuetify-dialog'
import 'vuetify-dialog/dist/vuetify-dialog.css'
import light from './theme/light'
import VuetifyToast from 'vuetify-toast-snackbar';

Vue.use(Vuetify, {
  components: {
    VSnackbar,
    VIcon,
    VBtn,
  }
});


const vuetify = new Vuetify({
  theme: {
    themes: {
      light
    },
    options: {
      customProperties: true
    }
  },
  options: {
    minifyTheme(css) {
      return process.env.NODE_ENV === 'production' ? css.replace(/[\r\n|\r|\n]/g, '') : css
    }
  },
  lang: {
    t: (key, ...params) => i18n.t(key, params),
  },

})

Vue.use(VuetifyDialog, {
  context: {
    vuetify
  },
  confirm: {
    actions: {
      false: {
        text: () => i18n.t('app.cancel')
      },
      true: {
        text: () => i18n.t('app.yes'),
        color: 'primary'
      }
    }
  }
})

Vue.use(VuetifyToast, {
  $vuetify: vuetify.framework,
  x: 'center',
  multiLine: true,
  showClose: false,
  color: '#555'
});

export default vuetify
